import { render, staticRenderFns } from "./DetailReplacementCost.vue?vue&type=template&id=4c6116c2"
import script from "./DetailReplacementCost.vue?vue&type=script&lang=js"
export * from "./DetailReplacementCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports